import apiPath from "../constants/apiPath";
import { Severty, ShowToast } from "../helper/toast";
import useRequest from "../hooks/useRequest";

export const UsersServices = () => {
    const { request } = useRequest();

    // Get all users/trainers  (with optional filters/pagination)
    const getUsers = async (params = {}) => {
        try {
            let users = []
            await request({
                url: `${apiPath.userList}?type=${params.type}&page=${params.page}&limit=${params.limit}&search=${params.search}&status=${params.status}&startDate=${params.startDate}&endDate=${params.endDate}`,
                method: "GET",
                onSuccess: (data) => {
                    if (data.status) {
                        users = data.data;
                    } else {
                        ShowToast(data.message, Severty.ERROR);
                        return null;
                    }
                },
                onError: (error) => {
                    ShowToast(error.response?.data?.message || "Failed to fetch users", Severty.ERROR);
                },
            });
            return users
        } catch (error) {
            console.warn(error);
        }
    };

    // Get single user by ID
    const getUserById = async (id) => {
        try {
            let user = {}
            await request({
                url: `${apiPath.user}/${id}`,
                method: "GET",
                onSuccess: (data) => {
                    if (data.status) {
                        user = data.data;
                    } else {
                        ShowToast(data.message, Severty.ERROR);
                        return null;
                    }
                },
                onError: (error) => {
                    ShowToast(error.response?.data?.message || "Failed to fetch user", Severty.ERROR);
                },
            });
            return user
        } catch (error) {
            console.warn(error);
        }
    };

    // Create a new user
    const createUser = async (payload, isEdit = false) => {
        try {
            await request({
                url: isEdit ? `${apiPath.user}/${payload.id}/update` : apiPath.userCreate,
                method: "POST",
                data: payload,
                onSuccess: (data) => {
                    if (data.status) {
                        ShowToast("Trainer created successfully", Severty.SUCCESS);
                    } else {
                        ShowToast(data.message, Severty.ERROR);
                    }
                },
                onError: (error) => {
                    ShowToast(error.response?.data?.message || "Failed to create user", Severty.ERROR);
                },
            });
        } catch (error) {
            console.warn(error);
        }
    };

    //Create a new trainer
    const createTrainer = async (payload, isEdit = false) => {
        try {
            await request({
                url: isEdit ? `${apiPath.user}/trainer/${payload.id}/update` : apiPath.userCreate + "/trainer",
                method: "POST",
                data: payload,
                onSuccess: (data) => {
                    if (data.status) {
                        ShowToast("User created successfully", Severty.SUCCESS);
                    } else {
                        ShowToast(data.message, Severty.ERROR);
                    }
                },
                onError: (error) => {
                    ShowToast(error.response?.data?.message || "Failed to create user", Severty.ERROR);
                },
            });
        } catch (error) {
            console.warn(error);
        }
    }

    //update status 
    const updateUserStatus = async (id, payload) => {
        try {
            await request({
                url: `${apiPath.user}/${id}/status`,
                method: "PATCH",
                data: payload,
                onSuccess: (data) => {
                    ShowToast(data.message, Severty.SUCCESS);
                    return data;
                },
                onError: (error) => {
                    ShowToast(
                        error?.response?.data?.message || "Failed to update user status",
                        Severty.ERROR
                    );
                },
            });
        } catch (error) {
            console.error("updateUserStatus error:", error);
            ShowToast("Something went wrong", Severty.ERROR);
        }
    };

    // Update an existing user
    const updateUser = async (id, payload) => {
        try {
            await request({
                url: `${apiPath.addEditCustomer}/${id}`,
                method: "PUT",
                data: payload,
                onSuccess: (data) => {
                    if (data.status) {
                        ShowToast("User updated successfully", Severty.SUCCESS);
                    } else {
                        ShowToast(data.message, Severty.ERROR);
                    }
                },
                onError: (error) => {
                    ShowToast(error.response?.data?.message || "Failed to update user", Severty.ERROR);
                },
            });
        } catch (error) {
            console.warn(error);
        }
    };

    // Delete a user
    const deleteUser = async (id) => {
        try {
            await request({
                url: `${apiPath.user}/${id}/delete`,
                method: "PATCH",
                onSuccess: (data) => {
                    if (data.status) {
                        ShowToast("User deleted successfully", Severty.SUCCESS);
                    } else {
                        ShowToast(data.message, Severty.ERROR);
                    }
                },
                onError: (error) => {
                    ShowToast(error.response?.data?.message || "Failed to delete user", Severty.ERROR);
                },
            });
        } catch (error) {
            console.warn(error);
        }
    };

    return {
        getUsers,
        getUserById,
        createUser,
        createTrainer,
        updateUserStatus,
        updateUser,
        deleteUser,
    };
};

